import React, { useEffect, useState, useCallback, useRef } from 'react';
import axios from 'axios';
import { tanimlarApi } from '../services/api';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const token = () => localStorage.getItem('token');
const headers = () => ({ Authorization: `Bearer ${token()}` });

const AYLAR = ['','Ocak','Şubat','Mart','Nisan','Mayıs','Haziran',
               'Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];

const YIL_BAS = 2023;

function sureFmt(dk: number) {
  if (!dk) return '—';
  const s = Math.floor(dk / 60);
  const d = dk % 60;
  return s > 0 ? `${s}s ${d}dk` : `${d}dk`;
}

function tarihFmt(iso: string) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('tr-TR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export default function ZiyaretAylikRapor() {
  const now = new Date();
  const [yil,        setYil]        = useState(now.getFullYear());
  const [ay,         setAy]         = useState(now.getMonth() + 1);
  const [filYonetici,setFilYonetici]= useState('');
  const [filIsletme, setFilIsletme] = useState('');
  const [kayitlar,   setKayitlar]   = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [yoneticiler,setYoneticiler]= useState<any[]>([]);
  const printRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    tanimlarApi.isletmelerListesi(false).then(r => setIsletmeler(r.data));
    axios.get(`${API}/api/kullanicilar/`, { headers: headers() })
      .then(r => setYoneticiler(r.data)).catch(() => {});
  }, []);

  const yukle = useCallback(() => {
    const p: any = { yil, ay };
    if (filYonetici) p.yonetici_id = filYonetici;
    if (filIsletme)  p.isletme_id  = filIsletme;
    axios.get(`${API}/api/ziyaret/`, { headers: headers(), params: p })
      .then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
  }, [yil, ay, filYonetici, filIsletme]);

  useEffect(() => { yukle(); }, [yukle]);

  // Özet tablolar
  const yoneticiOzet = kayitlar.reduce((acc: any, k) => {
    const ad = k.yonetici_ad || 'Belirtilmemiş';
    if (!acc[ad]) acc[ad] = { ad, sayi: 0, sure: 0 };
    acc[ad].sayi++;
    acc[ad].sure += k.sure_dk || 0;
    return acc;
  }, {});

  const isletmeOzet = kayitlar.reduce((acc: any, k) => {
    const key = k.isletme_id;
    if (!acc[key]) acc[key] = { ad: k.isletme_ad, kod: k.isletme_kod, sayi: 0, sure: 0 };
    acc[key].sayi++;
    acc[key].sure += k.sure_dk || 0;
    return acc;
  }, {});

  const konuOzet = kayitlar.reduce((acc: any, k) => {
    const konu = k.konu_ad || 'Belirtilmemiş';
    if (!acc[konu]) acc[konu] = { konu, sayi: 0 };
    acc[konu].sayi++;
    return acc;
  }, {});

  const toplamSure = kayitlar.reduce((s, k) => s + (k.sure_dk || 0), 0);

  const yoneticiOzetListe = Object.values(yoneticiOzet).sort((a: any, b: any) => b.sayi - a.sayi);
  const isletmeOzetListe  = Object.values(isletmeOzet).sort((a: any, b: any) => b.sayi - a.sayi);
  const konuOzetListe     = Object.values(konuOzet).sort((a: any, b: any) => b.sayi - a.sayi);

  const yazdir = () => window.print();

  const excelIndir = () => {
    const baslik = ['#', 'Yönetici', 'İşletme Kodu', 'İşletme Adı', 'Başlangıç', 'Bitiş', 'Süre', 'Konu', 'Amaç', 'Gözlemler', 'Katılımcılar'];
    const satirlar = kayitlar.map((k, i) => [
      i + 1, k.yonetici_ad || '', k.isletme_kod || '', k.isletme_ad || '',
      k.baslangic ? new Date(k.baslangic).toLocaleString('tr-TR') : '',
      k.bitis ? new Date(k.bitis).toLocaleString('tr-TR') : '',
      k.sure_dk ? `${Math.floor(k.sure_dk/60)}s ${k.sure_dk%60}dk` : '',
      k.konu_ad || '', k.amac || '', k.gozlemler || '', k.katilimcilar || '',
    ]);
    const csv = [baslik, ...satirlar].map(r => r.map(c => `"${String(c).replace(/"/g,'""')}"`).join(',')).join('\n');
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `ziyaret_${yil}_${String(ay).padStart(2,'0')}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const yilSecenekleri = [];
  for (let y = YIL_BAS; y <= now.getFullYear() + 1; y++) yilSecenekleri.push(y);

  return (
    <>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          .print-only { display: block !important; }
          body { background: #fff !important; }
          .card, .stat-card { box-shadow: none !important; border: 1px solid #ddd !important; }
        }
        .print-only { display: none; }
      `}</style>

      <div ref={printRef}>
        {/* Yazdır başlığı */}
        <div className="print-only" style={{ textAlign: 'center', marginBottom: 20, paddingBottom: 12, borderBottom: '2px solid #1a5276' }}>
          <h2 style={{ color: '#1a5276', fontSize: 18 }}>TİGEM — Aylık Ziyaret Raporu</h2>
          <p style={{ fontSize: 13, color: '#555', marginTop: 4 }}>
            {AYLAR[ay]} {yil} · {kayitlar.length} ziyaret
          </p>
        </div>

        <div className="no-print">
          <div className="page-header">
            <h1>📄 Aylık Ziyaret Raporu</h1>
            <p>Aylık detaylı ziyaret raporu ve istatistikleri</p>
          </div>
        </div>

        {/* Filtreler */}
        <div className="card no-print" style={{ marginBottom: 16, padding: '12px 16px' }}>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: '#888', display: 'block', marginBottom: 4 }}>YIL</label>
              <input type="number" className="search-input" style={{ width: 100 }} value={yil}
                onChange={e => setYil(Number(e.target.value))} />
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: '#888', display: 'block', marginBottom: 4 }}>AY</label>
              <select className="search-input" style={{ width: 140 }} value={ay}
                onChange={e => setAy(Number(e.target.value))}>
                {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
              </select>
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: '#888', display: 'block', marginBottom: 4 }}>YÖNETİCİ</label>
              <select className="search-input" style={{ width: 180 }} value={filYonetici}
                onChange={e => setFilYonetici(e.target.value)}>
                <option value="">Tüm Yöneticiler</option>
                {yoneticiler.map(y => <option key={y.id} value={y.id}>{y.ad_soyad}</option>)}
              </select>
            </div>
            <div>
              <label style={{ fontSize: 11, fontWeight: 600, color: '#888', display: 'block', marginBottom: 4 }}>İŞLETME</label>
              <select className="search-input" style={{ width: 210 }} value={filIsletme}
                onChange={e => setFilIsletme(e.target.value)}>
                <option value="">Tüm İşletmeler</option>
                {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
              </select>
            </div>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
              <button className="btn" style={{ background: '#f0f4f8', border: '1.5px solid #e0e7ef' }} onClick={excelIndir}>
                📥 CSV İndir
              </button>
              <button className="btn btn-primary" onClick={yazdir}>
                🖨️ Yazdır
              </button>
            </div>
          </div>
        </div>

        {/* Özet kartlar */}
        <div className="stats-grid" style={{ marginBottom: 16 }}>
          <div className="stat-card"><div className="stat-icon">📋</div>
            <div><div className="stat-value">{kayitlar.length}</div><div className="stat-label">Toplam Ziyaret</div></div>
          </div>
          <div className="stat-card"><div className="stat-icon">🏢</div>
            <div><div className="stat-value">{Object.keys(isletmeOzet).length}</div><div className="stat-label">Ziyaret Edilen İşletme</div></div>
          </div>
          <div className="stat-card"><div className="stat-icon">👤</div>
            <div><div className="stat-value">{Object.keys(yoneticiOzet).length}</div><div className="stat-label">Aktif Yönetici</div></div>
          </div>
          <div className="stat-card"><div className="stat-icon">⏱️</div>
            <div><div className="stat-value">{sureFmt(toplamSure)}</div><div className="stat-label">Toplam Süre</div></div>
          </div>
        </div>

        {/* Ana tablo */}
        <div className="card" style={{ marginBottom: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <h3 style={{ margin: 0, fontSize: 14, color: '#1a5276' }}>
              📋 {AYLAR[ay]} {yil} Ziyaret Listesi
            </h3>
            <span style={{ fontSize: 12, color: '#888' }}>{kayitlar.length} kayıt</span>
          </div>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>#</th><th>Yönetici</th><th>İşletme</th>
                  <th>Başlangıç</th><th>Bitiş</th><th>Süre</th>
                  <th>Konu</th><th>Amaç / Not</th><th>Katılımcılar</th>
                </tr>
              </thead>
              <tbody>
                {kayitlar.map((k, i) => (
                  <tr key={k.id}>
                    <td style={{ color: '#888', fontSize: 11 }}>{i + 1}</td>
                    <td><strong>{k.yonetici_ad || '—'}</strong></td>
                    <td><strong>{k.isletme_kod}</strong><br /><small style={{ color: '#666' }}>{k.isletme_ad}</small></td>
                    <td style={{ whiteSpace: 'nowrap', fontSize: 12 }}>{tarihFmt(k.baslangic)}</td>
                    <td style={{ whiteSpace: 'nowrap', fontSize: 12 }}>{k.bitis ? tarihFmt(k.bitis) : '—'}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{sureFmt(k.sure_dk)}</td>
                    <td><span style={{ fontSize: 11, background: '#eaf2fb', color: '#1a5276', padding: '2px 7px', borderRadius: 10 }}>{k.konu_ad || '—'}</span></td>
                    <td style={{ maxWidth: 200, fontSize: 12, color: '#555' }}>
                      {k.amac || k.gozlemler ? (
                        <span title={[k.amac, k.gozlemler].filter(Boolean).join(' | ')}>
                          {[k.amac, k.gozlemler].filter(Boolean).join(' | ').slice(0, 80)}
                          {([k.amac, k.gozlemler].filter(Boolean).join(' | ')).length > 80 ? '…' : ''}
                        </span>
                      ) : '—'}
                    </td>
                    <td style={{ fontSize: 11, color: '#666' }}>{k.katilimcilar || '—'}</td>
                  </tr>
                ))}
                {kayitlar.length === 0 && (
                  <tr><td colSpan={9} style={{ textAlign: 'center', color: '#999', padding: 30 }}>
                    {AYLAR[ay]} {yil} için kayıt bulunamadı
                  </td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Özet tablolar */}
        {kayitlar.length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
            <div className="card">
              <h3 style={{ margin: '0 0 12px', fontSize: 13, color: '#1a5276' }}>👤 Yönetici Özeti</h3>
              <table style={{ width: '100%', fontSize: 12 }}>
                <thead><tr><th>Yönetici</th><th>Ziyaret</th><th>Süre</th></tr></thead>
                <tbody>
                  {yoneticiOzetListe.map((r: any) => (
                    <tr key={r.ad}>
                      <td>{r.ad}</td>
                      <td style={{ textAlign: 'center' }}>{r.sayi}</td>
                      <td style={{ textAlign: 'center' }}>{sureFmt(r.sure)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="card">
              <h3 style={{ margin: '0 0 12px', fontSize: 13, color: '#1a5276' }}>🏢 İşletme Özeti</h3>
              <table style={{ width: '100%', fontSize: 12 }}>
                <thead><tr><th>İşletme</th><th>Ziyaret</th><th>Süre</th></tr></thead>
                <tbody>
                  {isletmeOzetListe.map((r: any) => (
                    <tr key={r.kod}>
                      <td><strong>{r.kod}</strong> {r.ad}</td>
                      <td style={{ textAlign: 'center' }}>{r.sayi}</td>
                      <td style={{ textAlign: 'center' }}>{sureFmt(r.sure)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="card">
              <h3 style={{ margin: '0 0 12px', fontSize: 13, color: '#1a5276' }}>📌 Konu Dağılımı</h3>
              <table style={{ width: '100%', fontSize: 12 }}>
                <thead><tr><th>Konu</th><th>Adet</th><th>Oran</th></tr></thead>
                <tbody>
                  {konuOzetListe.map((r: any) => (
                    <tr key={r.konu}>
                      <td>{r.konu}</td>
                      <td style={{ textAlign: 'center' }}>{r.sayi}</td>
                      <td style={{ textAlign: 'center' }}>%{Math.round(r.sayi / kayitlar.length * 100)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
